import { FC } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const PAGE_SIZE = 5;

interface Props {
  page: number;
  total: number;
  totalPages: number;
  onChange: (page: number) => void;
  /** Distinguishes this paginator from the sibling ones for screen-reader users. */
  label: string;
}

const Paginator: FC<Props> = ({ page, total, totalPages, onChange, label }) => (
  <div className="tw-flex tw-items-center tw-justify-end tw-gap-x-4 tw-mt-3">
    <span className="tw-text-sm tw-font-atkinson tw-text-neutral-700">
      {Math.min((page + 1) * PAGE_SIZE, total)} of {total} students
    </span>
    <div className="tw-flex tw-gap-1">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page === 0}
        aria-label={`Previous page, ${label}`}
        className="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-neutral-200 tw-rounded-lg tw-bg-white tw-cursor-pointer disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
      >
        <ChevronLeft size={16} />
      </button>
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages - 1}
        aria-label={`Next page, ${label}`}
        className="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-neutral-200 tw-rounded-lg tw-bg-white tw-cursor-pointer disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  </div>
);

export default Paginator;
